<template>
  <!-- Image and text -->
  <nav class="navbar fixed-top">
    <div class="container">
      <div class="row">
        <div class="col nav-container">
          <a class="navbar-brand" href="#">
          <!-- <div class="d-block d-md-none">
            <img
              src="@/assets/img/_branding/rca_logo_vertical.png"
              width="auto" height="45px"
              class="d-inline-block align-middle"
              alt="Rowing Canada logo"
            >
          </div> -->
          <router-link to="/" class="d-block">
            <img
              src="@/assets/img/_branding/RCA_Identity-White.png"
              width="42px"
              height="auto"
              class="d-inline-block align-middle"
              alt="Rowing Canada logo"
            >
          </router-link>
        </a>

        <span class="navbar__text">
          <slot>CAC Template</slot>
        </span>

        <div>
          <!-- <a :href="`${publicPath}docs/rca-athlete-development-pathway.pdf`" target="_blank" class="navbar__menu-button disabled" aria-label="resources" role="resources"><font-awesome-icon icon="file" /></a> -->
          <!-- <button
            @click="$emit('toggleResource')"
            target="_blank" class="navbar__menu-button"
            aria-label="resources" role="resources">
            <font-awesome-icon icon="file" />
          </button> -->
          <button
            class="navbar__menu-button"
            aria-label="menu"
            @click="$emit('toggleMenu')"
          >
            <font-awesome-icon icon="bars"/>
          </button>
        </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  props: ['imgSrc'],
  data() {
    return {
      publicPath: process.env.BASE_URL,
    };
  },
};
</script>


<style lang="scss" scoped>
  /*------------------------------------*\
  #PRIMARY COLOURS
  \*------------------------------------*/
  $charcoal: #231F20;
  $red: #ED1B34;

  /*------------------------------------*\
  #Mixins
  \*------------------------------------*/

  /*------------------------------------
  #MEDIA SCREENS < 768px (#MOBILE FIRST)
  \*------------------------------------*/
  .navbar {
    background-color: red;
    // margin-bottom: 5rem;
    -webkit-animation: fadeIn 0.8s;
    animation: fadeIn 0.8s;
    box-shadow: $charcoal 0px 0px 5px;
    width: 100%;
    padding: 0 1rem;

    .nav-container {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: space-between;
      padding: 0px 1rem;
      width: 95vw;

      /*------------------------------------*\
        #MEDIA SCREENS > 767px (TABLETS)
      \*------------------------------------*/
      @media (min-width:767px) {
        width: 720px;
      }

      /*------------------------------------*\
        #MEDIA SCREENS > 992px
        (LAPTOP, TABLET)
      \*------------------------------------*/
      @media (min-width:992px) {
        width: 960px;
      }

      /*------------------------------------*\
        #MEDIA SCREENS > 1200px (DESKTOP)
      \*------------------------------------*/
      @media (min-width:1200px) {
        width: 1140px;
      }
    }

    /**
    * Elements
    */
    &__menu-button {
      padding: 0px 5px;
      color: #fff;
      font-size: 1.5rem;
      background: transparent;
      border: none;

      &:focus, &:focus {
        color: #ccc;
        transition: color .4s ease;
      }
    }

    &__text {
      color: #fff;
      // width: 30px;
      line-height: 1rem;
      font-weight: 700;
      font-family: 'Gotham', 'Montserrat', 'Open Sans', Arial, Helvetica, sans-serif
    }
  }


  /*------------------------------------*\
    #MEDIA SCREENS > 767px (TABLETS)
  \*------------------------------------*/
  @media (min-width:767px) {
    .navbar {
      /**
      * Elements
      */
      &__menu-button {
        background: transparent;
        border: none;
      }

      &__text {
        font-size: 1.5rem;
        width: 20rem;
        line-height: initial;
        text-align: left;
      }
    }
  }

  /*------------------------------------*\
    #MEDIA SCREENS > 992px
    (LAPTOP, TABLET)
  \*------------------------------------*/
  @media (min-width:992px) {

  }

  /*------------------------------------*\
    #MEDIA SCREENS > 1200px (DESKTOP)
  \*------------------------------------*/
  @media (min-width:1200px) {

  }

  /*------------------------------------*\
    #MEDIA SCREENS > 1320px (DESKTOP)
  \*------------------------------------*/
  @media (min-width:1320px) {

  }

  /*------------------------------------*\
    #MEDIA SCREENS > 1600px (DESKTOP)
  \*------------------------------------*/
  @media (min-width:1600px) {

  }
</style>
